import { ref, watch } from "vue";

/**
 * Whether the navigation rail is collapsed to icons.
 *
 * Module-level state, not provide/inject: the shell renders the rail and a
 * couple of screens want to know how much room they have. Threading a boolean
 * through every one of them would be worse than one shared ref for a preference
 * this small.
 *
 * PERSISTED, because it is a preference and not a mode. Someone who collapsed
 * the menu to read a wide table wants it collapsed tomorrow too — re-expanding
 * on every reload is the kind of small betrayal that makes a panel feel careless.
 *
 * ── HOJE ISTO É O ALFINETE ────────────────────────────────────────────────
 *
 * O gesto mudou de nome sem mudar de valor: recolhido, o rail abre sozinho ao
 * receber o mouse ou o foco, então o que este booleano decide não é mais "vejo
 * ou não vejo os rótulos" e sim "o painel FICA aberto". `collapsed === false` é
 * "fixado". A chave gravada continua querendo dizer exatamente o que já queria —
 * quem tem `benvox:nav-collapsed = 1` guardado pediu um rail estreito, e continua
 * recebendo um.
 */
const STORAGE_KEY = "benvox:nav-collapsed";

function readStored(): boolean {
	try {
		return localStorage.getItem(STORAGE_KEY) === "1";
	} catch {
		// Private browsing throws on read. A default is not a failure.
		return false;
	}
}

const collapsed = ref(readStored());

watch(collapsed, (value) => {
	try {
		localStorage.setItem(STORAGE_KEY, value ? "1" : "0");
	} catch {
		// See above — losing the preference is worse than crashing over it, and
		// neither is worth telling anyone about.
	}
});

export function useNavCollapse() {
	return {
		collapsed,
		toggle: () => {
			collapsed.value = !collapsed.value;
		},
	};
}
